import { Pipe, PipeTransform } from '@angular/core';
import { AutocompleteFilter } from '../models';

@Pipe({ name: 'filterAutocompleteHtml' })
export class FilterAutocompleteHtmlPipe implements PipeTransform {
  transform(filter: AutocompleteFilter, value: any): string {
    return filter.getAutocompleteHtml(value);
  }
}
